import { Stack } from "@mui/joy";
import { ReactNode } from "react";

import DeleteIconButton from "../DeleteIconButton";

// One side quest or boost in the Rules tab, edited in place.
export default function QuestPartCard({
  removeLabel,
  onRemove,
  children,
}: {
  removeLabel: string;
  onRemove: () => void;
  children: ReactNode;
}) {
  return (
    <Stack
      direction="row"
      gap={1.5}
      alignItems="flex-start"
      sx={{ borderRadius: 8, border: "1px solid", borderColor: "neutral.200", padding: 1.5 }}
    >
      <Stack gap={1.5} sx={{ flex: 1, minWidth: 0 }}>
        {children}
      </Stack>
      <DeleteIconButton
        sx={{ marginTop: 3.75, marginBottom: 0.25, marginRight: -0.5 }}
        aria-label={removeLabel}
        onClick={onRemove}
      />
    </Stack>
  );
}
